<template>
  <section id="features">
    <div class="container">
      <div class="row justify-content-center text-center mb-5">
        <div class="col-xl-8 col-lg-9">
          <h2 class="display-4 mx-xl-6">A complete suite.</h2>
          <p class="lead">Everything you need to build a closed domain question answering system.</p>
        </div>
      </div>
      <div class="row justify-content-center mb-5">
        <div class="col-xl-11">
          <ul class="nav justify-content-center" role="tablist">
            <li class="nav-item mx-1">
              <a
                class="nav-link active"
                href="#suite-tab-1"
                data-toggle="tab"
                role="tab"
                aria-controls="suite-tab-1"
                aria-selected="true"
              >
                <div class="icon-round icon-round-sm bg-primary">
                  <svg
                    class="icon bg-primary"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <title>Icon For Box#2</title>
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect opacity="0" x="0" y="0" width="24" height="24"></rect>
                      <path
                        d="M4,9.67471899 L10.880262,13.6470401 C10.9543486,13.689814 11.0320333,13.7207107 11.1111111,13.740321 L11.1111111,21.4444444 L4.49070127,17.526473 C4.18655139,17.3464765 4,17.0193034 4,16.6658832 L4,9.67471899 Z M20,9.56911707 L20,16.6658832 C20,17.0193034 19.8134486,17.3464765 19.5092987,17.526473 L12.8888889,21.4444444 L12.8888889,13.6728275 C12.9050191,13.6647696 12.9210067,13.6561758 12.9368301,13.6470401 L20,9.56911707 Z"
                        fill="#000000"
                      ></path>
                      <path
                        d="M4.21611835,7.74669402 C4.30015839,7.64056877 4.40623188,7.55087574 4.5299008,7.48500698 L11.5299008,3.75665466 C11.8237589,3.60013944 12.1762411,3.60013944 12.4700992,3.75665466 L19.4700992,7.48500698 C19.5654307,7.53578262 19.6503066,7.60071528 19.7226939,7.67641889 L12.0479413,12.1074394 C11.9974761,12.1365754 11.9509488,12.1699127 11.9085461,12.2067543 C11.8661433,12.1699127 11.819616,12.1365754 11.7691509,12.1074394 L4.21611835,7.74669402 Z"
                        fill="#000000"
                        opacity="0.3"
                      ></path>
                    </g>
                  </svg>
                </div>Python Library
              </a>
            </li>
            <li class="nav-item mx-1">
              <a
                class="nav-link"
                href="#suite-tab-2"
                data-toggle="tab"
                role="tab"
                aria-controls="suite-tab-2"
                aria-selected="false"
              >
                <div class="icon-round icon-round-sm bg-primary">
                  <svg
                    class="icon"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <title>Icon For Display#1</title>
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect opacity="0" x="0" y="0" width="24" height="24"></rect>
                      <path
                        d="M11,20 L11,17 C11,16.4477153 11.4477153,16 12,16 C12.5522847,16 13,16.4477153 13,17 L13,20 L15.5,20 C15.7761424,20 16,20.2238576 16,20.5 C16,20.7761424 15.7761424,21 15.5,21 L8.5,21 C8.22385763,21 8,20.7761424 8,20.5 C8,20.2238576 8.22385763,20 8.5,20 L11,20 Z"
                        fill="#000000"
                        opacity="0.3"
                      ></path>
                      <path
                        d="M3,5 L21,5 C21.5522847,5 22,5.44771525 22,6 L22,16 C22,16.5522847 21.5522847,17 21,17 L3,17 C2.44771525,17 2,16.5522847 2,16 L2,6 C2,5.44771525 2.44771525,5 3,5 Z M4.5,8 C4.22385763,8 4,8.22385763 4,8.5 C4,8.77614237 4.22385763,9 4.5,9 L13.5,9 C13.7761424,9 14,8.77614237 14,8.5 C14,8.22385763 13.7761424,8 13.5,8 L4.5,8 Z M4.5,10 C4.22385763,10 4,10.2238576 4,10.5 C4,10.7761424 4.22385763,11 4.5,11 L7.5,11 C7.77614237,11 8,10.7761424 8,10.5 C8,10.2238576 7.77614237,10 7.5,10 L4.5,10 Z"
                        fill="#000000"
                      ></path>
                    </g>
                  </svg>
                </div>User Interface
              </a>
            </li>
            <li class="nav-item mx-1">
              <a
                class="nav-link"
                href="#suite-tab-3"
                data-toggle="tab"
                role="tab"
                aria-controls="suite-tab-3"
                aria-selected="false"
              >
                <div class="icon-round icon-round-sm bg-primary">
                  <svg
                    class="icon"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <title>Icon For Price #1</title>
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <polygon opacity="0" points="0 0 24 0 24 24 0 24"></polygon>
                      <path
                        d="M3.52270623,14.028695 C2.82576459,13.3275941 2.82576459,12.19529 3.52270623,11.4941891 L11.6127629,3.54050571 C11.9489429,3.20999263 12.401513,3.0247814 12.8729533,3.0247814 L19.3274172,3.0247814 C20.3201611,3.0247814 21.124939,3.82955935 21.124939,4.82230326 L21.124939,11.2583059 C21.124939,11.7406659 20.9310733,12.2027862 20.5869271,12.5407722 L12.5103155,20.4728108 C12.1731575,20.8103442 11.7156477,21 11.2385688,21 C10.7614899,21 10.3039801,20.8103442 9.9668221,20.4728108 L3.52270623,14.028695 Z M16.9307214,9.01652093 C17.9234653,9.01652093 18.7282432,8.21174298 18.7282432,7.21899907 C18.7282432,6.22625516 17.9234653,5.42147721 16.9307214,5.42147721 C15.9379775,5.42147721 15.1331995,6.22625516 15.1331995,7.21899907 C15.1331995,8.21174298 15.9379775,9.01652093 16.9307214,9.01652093 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                      ></path>
                    </g>
                  </svg>
                </div>Annotator
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-xl-11">
          <div class="tab-content">
            <div
              class="tab-pane fade show active"
              id="suite-tab-1"
              role="tabpanel"
              aria-labelledby="suite-tab-1"
            >
              <div class="container">
                <div class="row align-items-center justify-content-between o-hidden">
                  <div class="col-md-9 order-sm-2 mb-5 mb-sm-0">
                    <img
                      src="../assets/img/suite-1.png"
                      width="100%"
                      alt="Image"
                      class="mt-3 justify-content-center"
                    >
                  </div>
                  <div class="col-md-3 pr-xl-5 order-sm-1">
                    <p>✅ Convert your dataset to a compatible format.</p>
                    <p>✅ Create your question answering model in minutes.</p>
                    <p>✅ Deploy your model as a service.</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="suite-tab-2"
              role="tabpanel"
              aria-labelledby="suite-tab-2"
            >
              <div class="container">
                <div class="row align-items-center justify-content-between o-hidden">
                  <div class="col-md-9 order-sm-2 mb-5 mb-sm-0">
                    <img
                      src="../assets/img/suite-2.png"
                      width="100%"
                      alt="Image"
                      class="mt-3 justify-content-center"
                    >
                  </div>
                  <div class="col-md-3 pr-xl-5 order-sm-1">
                    <p>✅ Interact with your model in real-time.</p>
                    <p>✅ Customise your interface.</p>
                    <p>✅ Share your work with your peers.</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="suite-tab-3"
              role="tabpanel"
              aria-labelledby="suite-tab-3"
            >
              <div class="container">
                <div class="row align-items-center justify-content-between o-hidden">
                  <div class="col-md-9 order-sm-2 mb-5 mb-sm-0">
                    <img
                      src="../assets/img/suite-3.png"
                      width="100%"
                      alt="Image"
                      class="mt-3 justify-content-center"
                    >
                  </div>
                  <div class="col-md-3 pr-xl-5 order-sm-1">
                    <p>✅ Label your dataset to evaluate or fine-tune your question answering model.</p>
                    <p>✅ Work offline so your data never leaves your computer.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Suite"
};
</script>

<style>
</style>